import {
  Button,
  Dialog,
  DialogContent,
  IconButton,
  Stack,
  TextField,
  Toolbar,
  Typography,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import {
  DateFormater,
  GetReadOnlyInputProps,
  Loader,
} from "../../../../HelperFunctions/HelperFunctions";
import { DatePicker } from "rsuite";
import { useState } from "react";
import {
  chargebackIrreversible,
  chargebackReversed,
  getReversedAndResponded,
} from "../../../../API/backendAPI";
import { enqueueSnackbar } from "notistack";
import { useRouteLoaderData } from "react-router-dom";
import { Padding } from "@mui/icons-material";

const StatusDialog = ({ open, onClose, onStatusUpdate, chargeBacksReversedDate }) => {
  const { userId } = useRouteLoaderData("reconciliation");
  const [date, setDate] = useState(new Date());
  const [reason, setReason] = useState("");
  const [loading, setLoading] = useState(false);

  const DEAFULT = {
    width: 350,
    "& .MuiInputBase-input.Mui-disabled": {
      WebkitTextFillColor: "black",
    },
  };

  const labelDefault = {
    fontFamily: "Poppins, sans-serif",
    fontSize: "14px",
    padding: "15px",
    marginLeft: "30px",
  };


  const today = new Date();
  today.setHours(0, 0, 0, 0);

  const handleSave = async () => {
    if (loading) return; // Prevent multiple clicks

    // if (!reason && open.option.statusValue === "irreversible") {
    //   enqueueSnackbar("Please enter the Reason", { variant: "warning" });
    //   return;
    // }
    if (open.option.statusValue !== "irreversible" && !date) {
      enqueueSnackbar("Please enter the Date", { variant: "warning" });
      return;
    }
    if (
      open.option.statusValue === "reversed" &&
      chargeBacksReversedDate &&
      new Date(date) <= new Date(chargeBacksReversedDate)
    ) {
      const confirmContinue = window.confirm(
        "Reversal date shouldn't be less than the charge back date, Do you wish to continue?"
      );

      if (!confirmContinue) return;
    }


    try {
      setLoading(true);
      const reversedAndRespondedPayload = {
        id: open.data._id,
        [open.option.statusValue === "reversed" ? "reversal_date" : "date"]:
          DateFormater(date),
        user_id: userId,
      };

      const irreversiblePayload = {
        id: open.data._id,
        reason,
        user_id: userId,
      };
      const url =
        open.option.statusValue === "reversed"
          ? "chargeback_reversed"
          : open.option.statusValue === "responded"
            ? "chargeback_responded"
            : "chargeback_irreversible";

      const response = await (open.option.statusValue === "irreversible"
        ? chargebackIrreversible(url, irreversiblePayload)
        : getReversedAndResponded(url, reversedAndRespondedPayload));

      // Check if the response has the expected structure
      // The API returns { updated_to: "...", _id: "..." } on success
      // If there's an error, response might be undefined or an error object
      if (!response || !response._id || !response.updated_to) {
        enqueueSnackbar("Failed to update status", { variant: "error" });
        return;
      }

      enqueueSnackbar("Status updated successfully", {
        variant: "success",
      });

      try {
        if (onStatusUpdate) {
          onStatusUpdate(response);
        }
      } catch (updateError) {
        console.error("Error in onStatusUpdate:", updateError);
      }

      setDate(new Date());
      setReason("");
      onClose();
    } catch (error) {
      console.error("Error updating status:", error);
      enqueueSnackbar("Error while changing the status", { variant: "error" });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog
      open={open.open}
      maxWidth={false}
      // sx={{
      //     "& .MuiDialog-paper": {
      //         width: "80%",
      //     },
      // }}
      sx={{
        width: "100%",
        "& .MuiDialog-container": {
          alignItems: "flex-start",
        },
        "& .MuiDialog-paper": {
          width: "45%", // <— now width works!
          maxWidth: "none",
          marginTop: 33,
        },
      }}
    >
      <Toolbar sx={{ bgcolor: "#d7d7d7" }}>
        <Typography
          sx={{
            ml: 2,
            flex: 1,
            color: "#1f1f1f",
          }}
          component="div"
          fontWeight={600}
          fontSize={"16px"}
        >
          {`Chargeback ${open.option.statusName}`}
        </Typography>
        <Stack direction="row" spacing={2} alignItems="center">
          <Button
            size="small"
            disableRipple
            disableElevation
            variant="contained"
            disabled={loading}
            sx={{
              px: 4,
              textTransform: "none",
              backgroundColor: "#b5dcf2",
              color: "#000",
            }}
            onClick={handleSave}
          >
            Save
          </Button>
          <IconButton
            size="small"
            edge="start"
            onClick={onClose}
            style={{ backgroundColor: "#686868", borderRadius: "50", marginRight: 2 }}
            disableRipple
          >
            <CloseIcon sx={{ color: "white" }} />
          </IconButton>
        </Stack>
      </Toolbar>

      <DialogContent sx={{ padding: 0.9 }}>
        <Stack direction={"column"} gap={0}>
          <Stack
            direction={"row"}
            justifyContent={"space-between"}
            // gap={14}

            alignItems={"center"}
          >
            <label style={{ ...labelDefault }}>Chargeback Case #</label>
            <TextField
              value={open.data.case_number}
              disabled
              variant="filled"
              inputProps={{
                style: { marginBottom: 15 },
              }}
              sx={DEAFULT}
            />
          </Stack>
          <Stack
            direction={"row"}
            justifyContent={"space-between"}
            //  gap={25}
            alignItems={"center"}
          >
            <label style={{ ...labelDefault }}>Amount</label>
            <TextField
              value={open.data.amount}
              disabled
              variant="filled"
              inputProps={{
                style: { textAlign: "right", marginBottom: 15 },
              }}
              sx={DEAFULT}
            />
          </Stack>
          <Stack
            direction={"row"}
            justifyContent={"space-between"}
            // gap={25.4}
            alignItems={"center"}
          >
            {open.option.statusValue !== "irreversible" ? (
              <>
                <label style={{ ...labelDefault }}>{open?.option?.statusValue === "responded" ? "Responded Date" : "Reversal Date"}<span style={{ color: "red", fontSize: "12px" }}>*</span> </label>
                <DatePicker
                  value={date}
                  onChange={(value) => setDate(value)}
                  format="MM/dd/yyyy"
                  oneTap
                  ranges={[
                    {
                      label: "Today",
                      value: today,
                    },
                    // {
                    //   label: "Yesterday",
                    //   value: yesterday,
                    // },
                    {
                      label: "Clear",
                      value: null,
                    },
                  ]}
                  menuStyle={{ zIndex: 1400 }}
                  size="lg"
                  placement="autoVerticalStart"
                  style={{ minWidth: 350 }}
                />
              </>
            ) : (
              <>
                <label style={{ ...labelDefault }}>Reason</label>
                <TextField
                  id="outlined-multiline-static"
                  // label="Multiline"
                  multiline
                  rows={1}
                  value={reason}
                  onChange={(e) => setReason(e.target.value)}
                  sx={{ width: 350 }}
                />
              </>
            )}
          </Stack>
        </Stack>
      </DialogContent>
      {loading && <Loader loading={loading} />}
    </Dialog>
  );
};

export default StatusDialog;
